<template>
  <div id="map-location"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {
    // val:经纬度合集
    // row：运单信息
    // type:是否定位到了点
    init(val, row, type) {
      let map = new AMap.Map("map-location", {
        //'map-location'是对应页面盒子的id
        resizeEnable: true, //自适应大小
        zoom: 10, //初始视窗
        // center:[val[0].lng,val[0].lat]
      });
      console.log(type);
      if (type) {
        AMap.plugin("AMap.Driving", () => {
          //构造路线导航类
          var driving = new AMap.Driving({
            map: map,
            resizeEnable: true,
            showTraffic: false,
            policy: AMap.DrivingPolicy.LEAST_TIME,
          });
          let sta = val[0];
          let end = val.pop();
          let path = [];
          val.forEach((item) => {
            path.push(new AMap.LngLat(item.lng, item.lat));
          });
          driving.search(
            new AMap.LngLat(sta.lng, sta.lat),
            new AMap.LngLat(end.lng, end.lat),
            { waypoints: path },
            function (status, result) {
              // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
              if (status === "complete") {
                //这个是添加AMapUI的点标注
                AMapUI.loadUI(["overlay/SimpleMarker"], (PathSimplifier) => {
                  const marker = new PathSimplifier({
                    iconLabel: "起",
                    iconStyle: "red",
                    color: "#fffff",
                    map: map,
                    radius: 5,
                    position: [val[0].lng, val[0].lat],
                    iconStyle: {
                      src: "//webapi.amap.com/theme/v1.3/markers/b/mark_b.png",
                      style: {
                        width: "20px",
                        height: "30px",
                        color: "#f5f5f5",
                      },
                    },
                  });
                });
                // 如果是定位中，则覆盖终点图标
                if (row.position_status == "Positioning") {
                  AMapUI.loadUI(["overlay/SimpleMarker"], (PathSimplifier) => {
                    const marker = new PathSimplifier({
                      // iconLabel: "经" ,
                      iconStyle: "red",
                      color: "#fffff",
                      map: map,
                      radius: 5,
                      position: [end.lng, end.lat],
                      offset: new AMap.Pixel(-12, -32),
                      iconStyle: {
                        src: "//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png",
                        style: {
                          width: "25px",
                          height: "35px",
                          color: "#f5f5f5",
                        },
                      },
                    });
                  });
                }
                // log.success('绘制驾车路线完成')
                val.forEach((item, i) => {
                  if (i != 0) {
                    var marker = new AMap.Marker({
                      position: new AMap.LngLat(item.lng, item.lat),
                      icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png", // 添加 Icon 图标 URL
                      offset: new AMap.Pixel(-12, -32),
                      title: "",
                    });
                    marker.setTitle(item.track_time + "," + item.address);
                    marker.setMap(map);
                  }
                });
              } else {
                // log.error('获取驾车数据失败：' + result)
              }
            }
          );
        });
        // 没有定位到点
      } else {
        map.plugin("AMap.Geocoder", () => {
          //通过传入的地址获取经纬度
          var geocoder = new AMap.Geocoder({});
          AMap.plugin("AMap.Driving", () => {
            geocoder.getLocation(val, function (status, result) {
              if (status === "complete" && result.info === "OK") {
                // 构造路线导航类
                var driving = new AMap.Driving({
                  map: map,
                  resizeEnable: true,
                  showTraffic: false,
                  policy: AMap.DrivingPolicy.LEAST_TIME,
                });
                map.setCenter([
                  result.geocodes[0].location.lng,
                  result.geocodes[0].location.lat,
                ]);
                // result中对应详细地理坐标信息
                let path = [];
                driving.search(
                  new AMap.LngLat(
                    result.geocodes[0].location.lng,
                    result.geocodes[0].location.lat
                  ),
                  {
                    waypoints: path, //设置途经点
                  },
                  function (status, res) {
                    AMapUI.loadUI(
                      ["overlay/SimpleMarker"],
                      (PathSimplifier) => {
                        const marker = new PathSimplifier({
                          iconLabel: "起",
                          iconStyle: "red",
                          color: "#fffff",
                          map: map,
                          radius: 5,
                          position: [
                            result.geocodes[0].location.lng,
                            result.geocodes[0].location.lat,
                          ],
                          iconStyle: {
                            src: "//webapi.amap.com/theme/v1.3/markers/b/mark_b.png",
                            style: {
                              width: "20px",
                              height: "30px",
                              color: "#f5f5f5",
                            },
                          },
                        });
                      }
                    );
                  }
                );
              }
            });
          });
        });
      }
    },
  },
};
</script>
<style>
#map-location {
  width: 100%;
  height: 500px;
}
.amap-icon img {
  width: 25px;
  height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/map/emap-line.vue